<template>
  <div class="locale-switcher">
    <select v-model="$i18n.locale">
      <option :value="locale.code" v-for="locale in locales" :key="locale.code">
        {{locale.name}}
      </option>
    </select>
  </div>
</template>

<script>
import { getSupportedLocales } from "@/util/i18n/supported-locales"
export default {
  data: () => ({ 
      locales: getSupportedLocales() 
      })
}
</script>
<style scoped>
 .locale-switcher select {
        font-family: 'Arial';
        display: inline-block;
        width: 100%;
        cursor: pointer;
        padding: 10px 15px;
        outline: 0;
        border: 0px solid #000000;
        border-radius: 0px;
        background: #e6e6e6;
        color: #7b7b7b;
    }
</style>